// extracted by css-extract-rspack-plugin
export default {"ViewSectionRoot":"ViewSection-module__ViewSectionRoot___LxV9X"};